export default {
  CC_EXISTS: '/ccexists',
  ENTER_CC_DETAILS: '/EnterCCDetailsPage',
  PATIENT_LOOKUP: '/',
  CC_DOES_NOT_EXISTS: '/ccdoesnotexist',
  CC_CONFIRMATION: '/ccConfirmation'
};
